<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.auName" style="width: 130px" size="small"
                        placeholder="请输入姓名"></el-input>
                    <el-input v-model="formDatas.aubaThisName" style="width: 130px" size="small"
                        placeholder="请输入物品名称"></el-input>
                    <el-select v-model="formDatas.aubaType" clearable placeholder="请选择物品类型" @change="partserch"
                        size="small" style="width: 130px">
                        <el-option label="资产" :value="1" key="1"></el-option>
                        <el-option label="配件" :value="2" key="2"></el-option>
                        <el-option label="耗材" :value="3" key="3"></el-option>
                        <el-option label="手机卡" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.aubaBorrowApply" clearable placeholder="请选择类型" @change="partserch"
                        size="small" style="width: 130px">
                        <el-option label="领用" :value="1" key="1"></el-option>
                        <el-option label="借用" :value="2" key="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.aubaStatus" clearable placeholder="请选择申请状态" @change="partserch"
                        size="small" style="width: 130px">
                        <el-option label="待审核" :value="1" key="1"></el-option>
                        <el-option label="通过" :value="2" key="2"></el-option>
                        <el-option label="拒绝" :value="3" key="3"></el-option>
                        <el-option label="已归还" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增配件分类</el-button> -->

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="aubaId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑设备申请记录' : '新增申请记录'"
                :before-close="handleClose" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
                ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="领用日期" prop="aubaBorrowDate">
                                <el-date-picker v-model="form.aubaBorrowDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="类型" prop="aubaBorrowType">
                                <el-select v-model="form.aubaBorrowType" clearable placeholder="请选择"
                                    style="width: 130px">
                                    <el-option label="领用" :value="1" key="1"></el-option>
                                    <el-option label="借用" :value="2" key="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="计划规划日期" prop="aubaReturnPlanDate">
                                <el-date-picker v-model="form.aubaReturnPlanDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="备注" prop="aubaThisDes">
                                <el-input v-model="form.aubaThisDes" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="资产图片" prop="aubaImages">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr="fileList" :limit="5"
                                    @removeAfter="removeAfter" style="margin: 10px 5px 5px;">
                                </my-upload>

                                <!-- <el-input v-model="form.aaFiles" style="width: 80%;" disabled placeholder="请先上传"></el-input> -->
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div style="max-height: 700px; overflow-y: scroll">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                        <el-descriptions-item label="领用日期">{{ DetailArr.aubaBorrowDate }}</el-descriptions-item>
                        <el-descriptions-item label="类型">
                            <el-tag size="small">{{ DetailArr.aubaBorrowType == 1 ? '领用' : '借用' }}</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="物品类型">
                            <el-tag size="small">{{ DetailArr.aubaType == 1 ? '资产' : DetailArr.aubaType == 2 ? '配件' :
                        DetailArr.aubaType == 3 ? '耗材' : '手机卡' }}</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="此次物品">{{ DetailArr.aubaThisName }}</el-descriptions-item>
                        <el-descriptions-item label="数量">{{ DetailArr.aubaThisNum }}</el-descriptions-item>
                        <el-descriptions-item label="计划归还时间">{{ DetailArr.aubaReturnPlanDate }}</el-descriptions-item>
                        <el-descriptions-item label="备注">{{ DetailArr.aubaThisDes }}</el-descriptions-item>
                        <el-descriptions-item label="资产图片">
                            <el-image ref="scrImg" id="scrimg" :src="DetailArr.aubaImages.split(',')[0]" alt=""
                                fit="fill" style="width: 50px;height: 50px;"
                                :previewSrcList="DetailArr.aubaImages.split(',')"
                                v-if="DetailArr.aubaImages"></el-image>
                        </el-descriptions-item>
                        <el-descriptions-item label="签名图片">
                            <el-image ref="scrImg" id="scrimg" :src="DetailArr.aubaSign" alt="" fit="fill"
                                style="width: 50px;height: 50px;" :previewSrcList="[DetailArr.aubaSign]"
                                v-if="DetailArr.aubaSign"></el-image>
                        </el-descriptions-item>
                        <el-descriptions-item label="完整图片">
                            <el-image ref="scrImg" id="scrimg" :src="DetailArr.aubaSignScreenshot" alt="" fit="fill"
                                style="width: 50px;height: 50px;" :previewSrcList="[DetailArr.aubaSignScreenshot]"
                                v-if="DetailArr.aubaSignScreenshot"></el-image>
                        </el-descriptions-item>

                    </el-descriptions>


                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { updateAjUserBorrowApplyReturn, getAjUserBorrowApplyList, updateAjUserBorrowApplyCheck, updateAjUserBorrowApply, deleteAjUserBorrowApply, updateAjAssetsHitch, getAjUserBorrowApplyDetails } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            DetailArr: [],
            IsDetail: false,//详情
            fileList: [],
            BreakDown: false,//处理故障
            dialog: false,
            edit: false,
            form: {
                aubaId: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {

                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "aubaBorrowType",
                    key: "aubaBorrowType",
                    title: "资产类型",
                    fixed: 'left',
                    align: "center",
                    width: 80,
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"

                                >
                                    {row.aubaBorrowType == 1 ? '领用' : '借用 '}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "aubaType",
                    key: "aubaType",
                    title: "物品类型",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"

                                >
                                    {row.aubaType == 1 ? '资产' : row.aubaType == 2 ? '配件 ' : row.aubaType == 3 ? '耗材 ' : '手机卡'}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "aubaThisName",
                    key: "aubaThisName",
                    title: "借用物品",
                    align: "center",
                    fixed: 'left',
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getDetail(row.aubaId)}
                                >
                                    {row.aubaThisName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "aubaThisNumber",
                    key: "aubaThisNumber",
                    title: "资产编码",
                    align: "center",
                    width: 150,
                },

                {
                    field: "aubaThisNum",
                    key: "aubaThisNum",
                    title: "数量",
                    align: "center",
                    width: 80,
                },
                {
                    field: "aubaReturnPlanDate",
                    key: "aubaReturnPlanDate",
                    title: "计划归还时间",
                    align: "center",
                    width: 150,
                    // fixed:'left',

                },
                {
                    field: "auName",
                    key: "auName",
                    title: "申请人",
                    align: "center",
                    width: 80,
                },
                {
                    field: "aubaThisDes",
                    key: "aubaThisDes",
                    title: "备注",
                    align: "center",
                    width: 180,
                },
                {
                    field: "aubaImages",
                    key: "aubaImages",
                    title: "资产图片",
                    align: "center",
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubaImages ? <el-image ref="scrImg" id="scrimg" src={row.aubaImages.split(',')[0]} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={row.aubaImages.split(',')}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },
                },
                {
                    field: "aubaSign",
                    key: "aubaSign",
                    title: "签名图片",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubaSign ? <el-image ref="scrImg" id="scrimg" src={row.aubaSign} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={[row.aubaSign]}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },

                },
                {
                    field: "aubaSignScreenshot",
                    key: "aubaSignScreenshot",
                    title: "完整图片",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubaSignScreenshot ? <el-image ref="scrImg" id="scrimg" src={row.aubaSignScreenshot} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={[row.aubaSignScreenshot]}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },

                },
                {
                    field: "aubaCheckDes",
                    key: "aubaCheckDes",
                    title: "审核备注",
                    align: "center",
                    width: 180,
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "aubaStatus",
                    key: "aubaStatus",
                    title: "审核",
                    width: 200,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubaStatus == 1 ? <el-tag size="mini">待审核</el-tag> : row.aubaStatus == 2 ? <el-tag type="success" size="mini">通过</el-tag> : row.aubaStatus == 3 ? <el-tag type="danger" size="mini">拒绝</el-tag> : <el-tag type="success" size="mini">已归还</el-tag>
                                }
                                {
                                    row.aubaStatus == 1 ?
                                        <el-button
                                            size="mini" type="text" style="color:green" on-click={() => this.handleCheck(row)} > 通过审核 </el-button> : <span></span>
                                }
                                {
                                    row.aubaStatus == 1 ?
                                        <el-button
                                            size="mini" type="text" style="color:red" on-click={() => this.handleRefuseCheck(row)} > 拒绝通过 </el-button> : <span></span>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubaStatus == 2 && !row.aubaThisId  ?
                                        <el-button

                                            size="mini"
                                            type="text"
                                            on-click={() => this.handleReturn(row)}
                                        >
                                            归还
                                        </el-button> : ''
                                }
                                {
                                    row.aubaStatus == 1 ?
                                        <el-button

                                            size="mini"
                                            type="text"
                                            on-click={() => this.handleEdit(row)}
                                        >
                                            编辑
                                        </el-button> : ''
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                auId: '',
                auName: '',
                aubaThisName: '',
                aaId: '',
                aubaType: '',

                aubaBorrowApply: '',
                aubaStatus: '',
                aubaBorrowDateStart: '',
                aubaBorrowDateEnd: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        handleReturn(row) {
            this.$confirm("是否确定要归还吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserBorrowApplyReturn({ aubaId: row.aubaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "归还成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        /* 详情 */
        getDetail(id) {
            getAjUserBorrowApplyDetails({ aubaId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        handleCheck(row) {
            this.$prompt("请输入审核备注?", "确定要审核通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjUserBorrowApplyCheck({ aubaId: row.aubaId, aubaStatus: 2, aubaCheckDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleRefuseCheck(row) {
            this.$prompt("请输入审核备注?", "确定要拒绝通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    updateAjUserBorrowApplyCheck({ aubaId: row.aubaId, aubaStatus: 3, aubaCheckDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        removeAfter(file) {
            const url = this.form.aubaImages.findIndex(item => item === file)
            this.form.aubaImages.splice(url, 1)
        },
        // 上传图片
        fileChange(file) {
            console.log(this.form.aubaImages, file);
            if (this.form.aubaImages.length > 0 && this.form.aubaImages != '') {
                this.form.aubaImages.push(...file)
            } else {
                this.$set(this.form, 'aubaImages', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        // 处理故障
        CloseBreakDown() {
            this.BreakDown = false;

            this.$refs['formRef'].resetFields();
        },
        sureBreakDown() {
            this.$confirm("是否确定要处理故障吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjAssetsHitch(this.form).then(res => {
                        if (res.data) {
                            this.CloseBreakDown();
                            this.getList()
                            this.$message({
                                type: "success",
                                message: "处理成功!",
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjUserBorrowApply({ aubaIds: row.aubaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.aubaImages = data.aubaImages.split(',')
                console.log(this.form.aubaImages);
                if (this.form.aubaImages.length > 0 && this.form.aubaImages != '') {
                    this.form.aubaImages.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })
                }
            })

        },
        SureBtn() {
            if (!this.edit) {

            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.form));
                        console.log(newForm)
                        newForm.aubaImages = newForm.aubaImages.length > 0 ? newForm.aubaImages.filter(item => typeof item === 'string').join(',') : '';
                        updateAjUserBorrowApply(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.fileList = []
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {

            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aubaId = row.aubaId
                    console.log(jsonObj);
                    updateAjUserBorrowApply(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.aubaId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.aubaId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.aubaId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.aubaId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.aubaId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjUserBorrowApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjUserBorrowApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjUserBorrowApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>